import { Option, RoleType } from 'interfaces';
import { signOut } from 'next-auth/react';
import AppRoutes from 'const/routes';
import Icons from '@/const/icons';
import { signOutLawyer } from '@/lib';
/**
 * This function is meant to handle the options to be shown under the
 * user profile in the header
 * It appends the options to the baseOptions and returns the updated array.
 *
 * @param baseOptions The base options to which the new options will be appended
 * @param sessionStatus The session status to determine the options to add
 * @returns A new array of options
 */
export function buildHeaderUserProfileOptions(
	baseOptions: Option[],
	sessionStatus: string,
	role: RoleType
): Option[] {
	if (sessionStatus === 'authenticated' && role === 'client') {
		return baseOptions.concat([
			{
				label: 'Dashboard',
				name: 'dashboard',
				href: AppRoutes.CLIENTAPP_DASHBOARD,
				icon: Icons.category,
			},
			{
				label: 'My Cases',
				name: 'my-cases',
				href: AppRoutes.CLIENTAPP_MY_CASES,
				icon: Icons.briefcase,
			},
			{
				label: 'Explore All Cases',
				name: 'all-cases',
				href: `${AppRoutes.CLIENTAPP_ALL_CASES}`,
				icon: Icons.book,
			},
			{
				name: 'financial-recovery',
				label: 'Financial Recovery',
				href: AppRoutes.CLIENTAPP_FINANCIAL_RECOVERY,
				icon: Icons.moneyReceive,
			},
			{
				name: 'inbox',
				label: 'Inbox',
				href: AppRoutes.CLIENTAPP_INBOX,
				icon: Icons.sms,
			},
			{
				label: 'Customer Support',
				name: 'customer-support',
				href: AppRoutes.CLIENTAPP_CUSTOMER_SUPPORT,
				icon: Icons.question,
			},
			{
				label: 'Settings',
				name: 'settings',
				href: AppRoutes.CLIENTAPP_SETTINGS_PERSONAL,
				icon: Icons.settings,
			},
			{
				name: 'signout',
				label: 'Logout',
				icon: Icons.logout,
				onClick: async () => {
					await signOut({
						redirect: true,
						callbackUrl: AppRoutes.CLIENTAPP_AUTH_SIGN_IN,
					});
				},
			},
		]);
	}
	if (sessionStatus === 'authenticated' && role === 'lawyer') {
		return baseOptions.concat([
			{
				label: 'Dashboard',
				name: 'dashboard',
				href: AppRoutes.LAWYERAPP_DASHBOARD,
				icon: Icons.category,
			},
			{
				label: 'Cases',
				name: 'cases',
				href: AppRoutes.LAWYERAPP_CASES,
				icon: Icons.briefcase,
			},
			{
				label: 'Client Directory',
				name: 'client-directory',
				href: AppRoutes.LAWYERAPP_CLIENT_DIRECTORY,
				icon: Icons.book,
			},
			{
				label: 'Analytics',
				name: 'analytics',
				href: AppRoutes.LAWYERAPP_CLIENT_ANALYTICS,
				icon: Icons.graph,
			},
			// {
			// 	name: 'inbox',
			// 	label: 'Inbox',
			// 	href: AppRoutes.LAWYERAPP_INBOX,
			// 	icon: Icons.sms,
			// },
			{
				label: 'Admin',
				name: 'admin',
				href: AppRoutes.LAWYERAPP_ADMIN_PANEL,
				icon: Icons.profileUsers,
			},
			{
				label: 'Settings',
				name: 'settings',
				href: AppRoutes.LAWYERAPP_SETTINGS_PERSONAL,
				icon: Icons.settings,
			},
			{
				name: 'signout',
				label: 'Logout',
				icon: Icons.logout,
				onClick: async () => {
					signOutLawyer();
				},
			},
		]);
	} else if (sessionStatus === 'unauthenticated') {
		return baseOptions.concat([
			{
				name: 'signin',
				label: 'Sign In',
				href: AppRoutes.CLIENTAPP_AUTH_SIGN_IN,
			},
		]);
	}

	return baseOptions;
}

// Other builders/handlers can be added here with extra logic
